import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SigninComponent } from './signin/signin.component';
import { FormsModule } from '@angular/forms';
import { AuthenticationInterceptor } from './authentication-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SignoutComponent } from './signout/signout.component';
import { SharedModule } from '../shared/shared.module';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetComponent } from './reset/reset.component';

@NgModule({
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    FormsModule,
    SharedModule
  ],
  providers: [
    AuthenticationInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true }
  ],
  declarations: [SigninComponent, SignoutComponent, ForgotComponent, ResetComponent]
})
export class AuthenticationModule { }
